export default {
  sidepanel: (state) => state,
  isSame: (state) => (sidepanel) => {
    const isKeySame = state.key === sidepanel.key;
    const isIdSame = state.params.id === sidepanel.params.id && state.params.id !== undefined;
    return isKeySame && isIdSame;
  },
  isOpen: (state) => !!state.key,
};
